/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEdgeToEdge = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v5h-2V4H4v3H2zm0 20h20v-5h-2v3H4v-3H2zm13.707-6.295-1.414-1.414 1.293-1.293H8.414l1.293 1.293-1.414 1.414-3.707-3.707 3.707-3.707 1.414 1.414-1.293 1.293h7.172l-1.293-1.293 1.414-1.414 3.707 3.707z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEdgeToEdge as EdgeToEdge };
